import React from "react";

function RelatedPostsSkeleton() {
  return (
    <div className="bg-slate-100 py-12 animate-pulse">
      <div className="container mx-auto">
        <div className="h-8 bg-slate-200 rounded mb-8 w-40 mx-5 md:mx-0" />
        <div className="grid gap-5 md:grid-cols-3 mx-5 md:mx-0">
          {Array.from({ length: 3 }).map((_, idx) => (
            <div
              key={idx}
              className="bg-white rounded overflow-hidden border border-slate-200"
            >
              <div className="w-full h-48 bg-slate-200" />
              <div className="px-10 py-5 space-y-3">
                <div className="h-3 bg-slate-200 rounded w-1/2" />
                <div className="h-5 bg-slate-200 rounded w-3/4" />
                <div className="h-4 bg-slate-200 rounded w-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RelatedPostsSkeleton;